'use es6';

import { isValidElement, useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
import Big from 'UIComponents/elements/Big';
import UIFlex from 'UIComponents/layout/UIFlex';
import MediaQuery from 'marketplace-ui-common/layout/components/MediaQuery';
import MediaSize from '../layout/MediaSize';
import ResultsSection from './ResultsSection';
import * as ScreenSizes from '../../constants/layout/ScreenSizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StorefrontResultsHeader = ({
  className,
  title,
  description,
  resultsCount,
  renderedFiltersPanel,
  renderedResultsCount: passedRenderedResultsCount,
  renderedResultsFilters,
  renderedSortDropdown,
  searchTerm,
  ungatedMobile,
  viewToggle
}) => {
  const renderedResultsCount = useMemo(() => {
    if (passedRenderedResultsCount) return passedRenderedResultsCount;
    if (!resultsCount) return null;
    if ( /*#__PURE__*/isValidElement(resultsCount)) return resultsCount;
    const {
      start,
      end,
      total
    } = resultsCount;
    if (searchTerm) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "ecosystemMarketplaceCore.storefront.resultsHeader.searchResultsCount",
        options: {
          start,
          end,
          count: total,
          searchTerm
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "ecosystemMarketplaceCore.storefront.resultsHeader.resultsCount",
      options: {
        start,
        end,
        count: total
      }
    });
  }, [passedRenderedResultsCount, resultsCount, searchTerm]);
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [ungatedMobile &&
    /*#__PURE__*/
    // only show on mobile
    _jsx(MediaQuery, {
      maxScreenSize: ScreenSizes.SM,
      children: /*#__PURE__*/_jsx(ResultsSection, {
        className: "m-bottom-6",
        gutterSize: "sm",
        children: renderedResultsFilters
      })
    }), title && /*#__PURE__*/_jsx(ResultsSection, {
      className: ungatedMobile && 'm-bottom-5',
      gutterSize: "sm",
      children: /*#__PURE__*/_jsx(H1, {
        "aria-level": 1,
        "data-selenium-id": "storefront-results-header-title",
        className: 'is--heading-2' + (ungatedMobile ? " m-bottom-5" : ""),
        children: title
      })
    }), description && /*#__PURE__*/_jsx(ResultsSection, {
      children: /*#__PURE__*/_jsx(Big, {
        children: description
      })
    }), /*#__PURE__*/_jsx(ResultsSection, {
      "data-test-id": "desktop-controls",
      gutterSize: "xs",
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "between",
        wrap: "wrap",
        children: [/*#__PURE__*/_jsx(Big, {
          children: renderedResultsCount
        }), /*#__PURE__*/_jsx(MediaSize, {
          minDeviceSize: "sm",
          children: /*#__PURE__*/_jsxs("div", {
            children: [viewToggle, renderedSortDropdown]
          })
        })]
      })
    }), (renderedFiltersPanel || renderedSortDropdown) && /*#__PURE__*/_jsx(MediaSize, {
      maxDeviceSize: "xs",
      children: /*#__PURE__*/_jsxs(UIFlex, {
        justify: "between",
        className: "m-bottom-2",
        "data-test-id": "mobile-controls",
        children: [renderedFiltersPanel, renderedSortDropdown]
      })
    }), ungatedMobile ?
    /*#__PURE__*/
    // only show on desktop
    _jsx(MediaQuery, {
      minScreenSize: ScreenSizes.SM,
      children: /*#__PURE__*/_jsx(ResultsSection, {
        gutterSize: "sm",
        children: renderedResultsFilters
      })
    }) : /*#__PURE__*/_jsx(ResultsSection, {
      gutterSize: "sm",
      children: renderedResultsFilters
    })]
  });
};
StorefrontResultsHeader.propTypes = {
  description: PropTypes.node,
  title: PropTypes.node,
  renderedFiltersPanel: PropTypes.node,
  renderedResultsCount: PropTypes.node,
  renderedResultsFilters: PropTypes.node,
  renderedSortDropdown: PropTypes.node,
  resultsCount: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  })]),
  searchTerm: PropTypes.string,
  ungatedMobile: PropTypes.bool,
  className: PropTypes.string,
  viewToggle: PropTypes.node
};
export default StorefrontResultsHeader;